<div class="main-div">
    <div class="wrapper fadeInDown">
        <div id="formContent">
            <form class="passwordUpdateForm" [formGroup]="passwordUpdateForm" (ngSubmit)="onSubmit()">

                <div class="form-group mb-0">
                    <input type="password" class="form-control" id="password" placeholder="Şifre" formControlName="password">
                    <div class="text-danger" *ngIf="passwordUpdateForm.controls['password'].invalid
                                  && (passwordUpdateForm.controls['password'].dirty || passwordUpdateForm.controls['password'].touched)">
                        Şifre formatı hatalı
                    </div>
                </div>

                <div class="form-group mb-0">
                    <input type="password" class="form-control" id="confirmPassword" placeholder="Şifre(Tekrar)" formControlName="confirmPassword">
                    <div class="text-danger" *ngIf="passwordUpdateForm.controls['confirmPassword'].invalid
                                  && (passwordUpdateForm.controls['confirmPassword'].dirty || passwordUpdateForm.controls['confirmPassword'].touched)">
                        Şifre formatı hatalı
                    </div>
                </div>

                <button type="submit" class="btn btn-primary login-submit-btn" [disabled]="!passwordUpdateForm.valid">Şifre Güncelle</button>
            </form>
        </div>
    </div>
</div>